import { render, staticRenderFns } from "./CmExpandableLayer.vue?vue&type=template&id=1dbbfd06"
import script from "./CmExpandableLayer.vue?vue&type=script&lang=ts"
export * from "./CmExpandableLayer.vue?vue&type=script&lang=ts"
import style0 from "./CmExpandableLayer.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ModuleHeader: require('/app/components/base/ModuleHeader/ModuleHeader.vue').default,Modal: require('/app/components/base/Modal/Modal.vue').default,Headline: require('/app/components/base/Headline/Headline.vue').default})
